<template>
    <section class="tables">
        <vue-snotify></vue-snotify>
        <form class="forms-sample" ref="anyName" @submit.stop.prevent="onSubmit" autocomplete="off">
            <div class="row mt-5">
                <div class="col-md-12 d-flex align-items-stretch grid-margin">
                    <div class="row flex-grow">
                        <div class="col-12 grid-margin">

                            <div class="card">
                                <div class="card-header">
                                    <h4 class="card-title" v-if="!this.form.VideoID">Add Video</h4>
                                    <h4  class="card-title" v-if="this.form.VideoID">Update Video</h4>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-md-6 col-sm-6">


                                            <div class="row" style="height: auto;">
                                                
                                                <div class="col-md-12">
                                                    <b-form-group label="Video Title" label-for="Video Title">
                                                        <b-form-input type="text" id="VideoName" name="VideoName"
                                                            autocomplete="VideoName" placeholder="Video Name"
                                                            v-model="$v.form.VideoName.$model"
                                                            :state="$v.form.VideoName.$dirty ? !$v.form.VideoName.$error : null"
                                                            aria-describedby="input-1-live-feedback">
                                                        </b-form-input>
                                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a
                                                            required
                                                            field.
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </div>
                                                
                                            </div>

                                            <div class="row" style="height: auto;">
                                                
                                                <div class="col-md-12">
                                                    <b-form-group label="Module" label-for="is_Module">
                                                        <b-form-select name="ModuleID" v-model="form.ModuleID"
                                                            :options="allModules" class="mb-3" value-field="ModuleID"
                                                            text-field="ModuleName" @change="getWeeksByModule"
                                                            :state="$v.form.ModuleID.$dirty ? !$v.form.ModuleID.$error : null"
                                                            disabled-field="notEnabled">
                                                        </b-form-select>
                                                         <b-form-invalid-feedback id="input-1-live-feedback">This is a
                                                            required
                                                            field.
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </div>
                                                
                                            </div>

                                            <div class="row" style="height: auto;">
                                                
                                                <div class="col-md-12">
                                                    <b-form-group label="Week" label-for="WeekID">
                                                        <b-form-select name="WeekID" v-model="form.WeekID"
                                                            :options="allWeeks" class="mb-3" value-field="WeekID"
                                                            :state="$v.form.WeekID.$dirty ? !$v.form.WeekID.$error : null"
                                                            text-field="WeekName" disabled-field="notEnabled">
                                                        </b-form-select>
                                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a
                                                            required
                                                            field.
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </div>
                                                
                                            </div>


                                            <div class="row" style="height: auto;">
                                                
                                                <div class="col-md-12">
                                                    <b-form-group label="Video Link" label-for="Video Link">
                                                        <b-form-input type="text" id="Videolink" name="Videolink"
                                                            autocomplete="Videolink" placeholder="Video Link "
                                                            v-model="$v.form.Videolink.$model"
                                                            :state="$v.form.Videolink.$dirty ? !$v.form.Videolink.$error : null"
                                                            aria-describedby="input-1-live-feedback">
                                                        </b-form-input>
                                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a
                                                            required
                                                            field.
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </div>
                                                
                                            </div>



                                            <div class="row" style="height: auto;">
                                                
                                                <div class="col-md-12">
                                                    <b-form-group id="StartingDate" label="Starting Date"
                                                        label-for="StartingDate">
                                                        <b-form-input id="StartingDate" type="date"
                                                            v-model="form.StartingDate"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                
                                            </div>


                                            <div class="row" style="height: auto;">
                                                
                                                <div class="col-md-12">
                                                    <b-form-group id="EndingDate" label="EndingDate" label-for="EndingDate">
                                                        <b-form-input id="EndingDate" type="date"
                                                            v-model="form.EndingDate"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                
                                            </div>


                                            <div class="row" style="height: auto;">
                                                
                                                <div class="col-md-12">
                                                    <b-form-group id="Year" label="Year" label-for="Year">
                                                        <b-form-input id="Year" type="text"
                                                            v-model="form.Year"></b-form-input>
                                                    </b-form-group>
                                                </div>
                                                
                                            </div>


                                            <div class="row" style="height: auto;">
                                                
                                                <div class="col-md-12">
                                                    <b-form-group label="Video Order" label-for="VideoOrder">
                                                        <b-form-input type="number" id="VideoOrder" name="VideoOrder"
                                                            autocomplete="VideoOrder" placeholder="Video Order "
                                                            v-model="$v.form.VideoOrder.$model"
                                                            :state="$v.form.VideoOrder.$dirty ? !$v.form.VideoOrder.$error : null"
                                                            aria-describedby="input-1-live-feedback">
                                                        </b-form-input>
                                                        <b-form-invalid-feedback id="input-1-live-feedback">This is a
                                                            required
                                                            field.
                                                        </b-form-invalid-feedback>
                                                    </b-form-group>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-sm-6">
                                            <div class="row" style="height: 126px; ">
                                                <div class="col-md-12">
                                                    <b-form-group label="Description" label-for="Description">
                                                        <b-form-textarea id="Description" v-model="form.Description"
                                                            placeholder="Enter something..." rows="3" max-rows="6">
                                                        </b-form-textarea>
                                                    </b-form-group>
                                                </div>
                                            </div>
                                            <div class="row" style="height: auto; ">
                                                <div class="col-md-4">
                                                    <b-form-group class="Scott Notes flex-notes" label="Scott Notes"
                                                        label-for="ScottNotes">
                                                        <b-form-checkbox id="Scott Notes" name="ScottNotes" value="1"
                                                            unchecked-value="0" v-model="form.ScottNotes"
                                                            aria-describedby="input-1-live-feedback">
                                                        </b-form-checkbox>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-4">
                                                    <b-form-group class="active flex-notes" label="Active" label-for="Active">
                                                        <b-form-checkbox id="Active" name="Active" value="1"
                                                            unchecked-value="0" v-model="form.Active"
                                                            aria-describedby="input-1-live-feedback">
                                                        </b-form-checkbox>
                                                    </b-form-group>
                                                </div>
                                                <div class="col-md-4">
                                                    <b-form-group class="Archive flex-notes" label="Archive" label-for="Archive">
                                                        <b-form-checkbox id="Archive" name="Archive" value="1"
                                                            unchecked-value="0" v-model="form.Archive"
                                                            aria-describedby="input-1-live-feedback">
                                                        </b-form-checkbox>
                                                    </b-form-group>
                                                </div>
                                            </div>
                                            <b-form-group>
                                                <h5 class="text-danger">Skill Sets:</h5>
                                                <div class="checkboxes row">
                                                    <div class="checkbox-field col-md-6 " v-for="skill in skills"
                                                        :key="skill.SkillSetID">
                                                        <th> <input :id="'s' + skill.SkillSetID"
                                                                :checked="form[`SkillSetID${skill.SkillSetID}`] == 1"
                                                                @input="updateSkillSetId(skill.SkillSetID, $event.target.checked)"
                                                                name="Webinar" type="checkbox">
                                                            <label :for="`s${skill.SkillSetID}`">{{ skill.SkillSetName
                                                            }}</label>
                                                        </th>
                                                    </div>
                                                </div>
                                            </b-form-group>

                                        </div>

                                    </div>
                                    <div class="row">
                                        <div class="col-md-6"></div>
                                        <div class="col-md-6 mt-3">
                                            <b-button type="submit" variant="success" :disabled="isDisabled"
                                                class="btn float-right btn-success">
                                                <span v-if="!this.form.VideoID">Submit</span>
                                                <span v-if="this.form.VideoID">Update</span>
                                            </b-button>
                                        </div>
                                    </div>
                                    <!--                                </form>-->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </section>
</template>

<script>
import Vue from "vue";
import API from '@/api'
import { validationMixin } from "vuelidate";
import { required, minLength, email, requiredIf, sameAs, integer } from "vuelidate/lib/validators";
import moment from 'moment'
import router from '../router';

export default {
    name: 'Users',
    mixins: [validationMixin],
    data() {
        return {
            allModules: [
                {
                    ModuleID: "",
                    ModuleName: "Select a module"
                }
            ],
            allWeeks: [
                {
                    WeekID: "",
                    WeekName: "Select a week",
                    WeekNumber: ""
                }
            ],
            ServiceByOptions: [{ item: 0, name: '---Select Type---' }],

            MemberByOptions: [{ item: 0, name: '---Select Member---' }],
            form: {
                VideoID: '',
                VideoName: '',
                Videolink: '',
                StartingDate: moment().format('YYYY-MM-DD'),
                EndingDate: moment().format('YYYY-MM-DD'),
                Year: '',
                Active: 0,
                ScottNotes: 0,
                Archive: 0,
                VideoOrder: '',
                Description: '',
                VendorID: '1',
                ModuleID: '',
                WeekID: '',
            },
            skills: {},
            skillSetIds: {},

            isDisabled: false,
            readonly: true,
            member: {},
        };
    },
    validations: {
        form: {
            VideoName: {
                required,
            },
            Videolink: {
                required,
            },
            VideoOrder: {
                required,
            },
            ModuleID: {
                required,
            },
            WeekID: {
                required,
            },
        }
    },
    mounted() {
        this.editMember();
        this.getAllSkills();
        this.getAllModules();
    },
    methods: {
        updateSkillSetId(skillId, checked) {
            this.$set(this.skillSetIds, 'SkillSetID' + skillId, checked ? 1 : 0);
        },

        getAllSkills() {
            API.getAllSkills(this.getAllSkillsCB, this.errorCB);
        },
        getAllSkillsCB(res) {
            this.skills = res.data;
            console.log(this.skills)
        },
        getAllModules() {
            API.getAllModules(this.getAllModulesCB, this.errorCB);
        },
        getAllModulesCB(res) {
            res.data.forEach(element => {
                this.allModules.push(element)
            });
        },
        getWeeksByModule() {
            API.getWeeksByModule({ moduleID: this.form.ModuleID }, this.getWeeksByModuleCB, this.errorCB)
        },
        getWeeksByModuleCB(res) {
            res.data.forEach(element => {
                this.allWeeks.push(element)
            });
        },
        onSubmit() {

            this.$v.form.$touch();
            // console.log('sum',this.$v.form)
            if (this.$v.form.$anyError) {
                return;
            }
            this.isDisabled = true;
          console.log(this.form);
            API.addUpdateVideo({ ...this.form, ...this.skillSetIds },
                data => {
                    this.isDisabled = false;
                    if (!this.form.VideoID) {
                        if (data.status === 410) {
                            this.$showNotification(data, 'error')
                        } else {
                            this.$showNotification(data, 'success')
                            this.submitForm();
                            // this.$router.push({name:"ViewVideos"})
                        }
                    } else {
                        if (data.status === 200) {
                            this.$showNotification(data, 'success')
                            this.submitForm();
                            this.$router.push({name:"ViewVideos"})
                        } else {
                            this.$showNotification({message:'Please try again.'}, 'error')
                        }

                    }
                },
                err => {
                    this.isDisabled = false;
                    this.$showNotification({message:'Failed system error'}, 'error')

                }
            )
        },
        editMember() {
            if (this.$route.params.user) {
                console.log(this.$route.params.user)
                this.member = this.$route.params.user;
                this.form = this.member;
                
                if (this.member.StartingDate && moment(this.member.StartingDate).isValid()) {
                    this.form.StartingDate = moment(this.member.StartingDate).format('YYYY-MM-DD');
                }

                // Check and assign the EndingDate if it exists and is not null
                if (this.member.EndingDate && moment(this.member.EndingDate).isValid()) {
                    this.form.EndingDate = moment(this.member.EndingDate).format('YYYY-MM-DD');
                }
                this.getWeeksByModule({ moduleID: this.form.ModuleID });
                // this.skillSetIds = this.member
            }
        },
        submitForm() {
            this.$refs.anyName.reset();
        },
        errorCB(err) {
            console.log(err)
            this.$showNotification({ message: "Failed system error" }, 'error')
        }
    }, computed: {},
}
</script>
